import posthog from "posthog-js";
import {
  POSTHOG_KEY,
  isPostHogEnabled,
  posthogConfig,
} from "./config";

let isInitialized = false;

/**
 * Initializes the PostHog JS client once (browser only).
 * Safe to call multiple times — subsequent calls are no-ops.
 */
export const initPostHog = () => {
  if (typeof window === "undefined" || isInitialized) {
    return posthog;
  }

  if (!isPostHogEnabled) {
    if (process.env.NODE_ENV === "development") {
      console.warn(
        "[PostHog] REACT_APP_POSTHOG_KEY is missing. Analytics is disabled."
      );
    }
    return posthog;
  }

  posthog.init(POSTHOG_KEY, posthogConfig);
  isInitialized = true;
  return posthog;
};

/**
 * Returns the shared PostHog client instance.
 * Prefer the analytics service helpers for app code.
 */
export const getPostHogClient = () => posthog;

export default posthog;
